module.exports = __webpack_public_path__ + "4c74ef4a01aac15fc3e4ea2d7d7b0ea7.jpg";